import { render, staticRenderFns } from "./ProcessDetail.vue?vue&type=template&id=21f6f560&"
import script from "./ProcessDetail.vue?vue&type=script&lang=js&"
export * from "./ProcessDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f6f560')) {
      api.createRecord('21f6f560', component.options)
    } else {
      api.reload('21f6f560', component.options)
    }
    module.hot.accept("./ProcessDetail.vue?vue&type=template&id=21f6f560&", function () {
      api.rerender('21f6f560', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/gva-wfd/components/DetailPanel/ProcessDetail.vue"
export default component.exports